/**
 * Ayudas de presentación de la bandeja de regularizaciones (007 · T048/T049).
 *
 * La UI **no** calcula huecos, límites ni permisos (contracts/ui.md): solo formatea lo que devuelve
 * la API. Horas en 24 h con la zona que corresponde a cada dato (wiring §0.5): el ancla y las
 * vecinas con su `site_timezone`, la propuesta con su `time_zone` y lo nuevo con la zona vigente
 * de la sede (`site.timezone`).
 */
import type { AttendanceAction, RegularizationAdmin } from '@fermin/contracts';

import { t } from '../../i18n';

/** `YYYY-MM-DD` → `23/09/2026` (mismo formato que `formatDate` del Admin, sin tocar zonas). */
export function formatLocalDay(day: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(day);
  return match ? `${match[3]}/${match[2]}/${match[1]}` : day;
}

export function workerFullName(
  worker: Pick<RegularizationAdmin['worker'], 'first_names' | 'last_names' | 'anonymized'>,
): string {
  const name = `${worker.first_names} ${worker.last_names}`.trim();
  return name.length > 0 ? name : t('regularizations.table.anonymized');
}

/** "Entrada"/"Salida" de la marca que falta. */
export function missingLabel(type: AttendanceAction): string {
  return t(`regularizations.missing.${type}`);
}

/** Tipo en minúsculas para frases ("… la hora de salida"). */
export function missingLabelLower(type: AttendanceAction): string {
  return missingLabel(type).toLocaleLowerCase('es-PE');
}

/**
 * Instante de referencia para la antigüedad ("Hace"): cuándo propuso el trabajador si ya lo hizo;
 * si no (pedida), cuándo se creó la solicitud.
 */
export function ageReference(
  request: Pick<RegularizationAdmin, 'proposal' | 'created_at'>,
): string {
  return request.proposal?.requested_at ?? request.created_at;
}
